'use strict';

/* Controllers */

app.controller('LoginController', ['$scope', '$rootScope', '$location', 'Auth', 'Helper', 'User', 'Popup', 
    function ($scope, $rootScope, $location, Auth, Helper, User, Popup) {

        Auth.redirectIfLoggedIn();

        $scope.login_started = false;


  		/**
  		 * called when user submits login form
  		 */
        $scope.loginUser = function() {

        	if( $scope.login_started ) return;

        	$scope.login_started = true;

            Auth.login($scope.username, $scope.password, function(resp, status) {
                if(status == 200) {
                	// success
                    Auth.setCredentials(resp.data.user);

                    // get credit
                    User.getCredit(function(){
                    	
	                    // this will go to intended or landing page
	                    Auth.redirectIfLoggedIn();
                    });

                }
                else if(status == 400 || status == 401) {
                    
                    switch(resp.data.code){
                    	case 'EE1000':
                    	case 'EE1001':
                    		Popup.error('You have entered an invalid username or password.');
                    		break;
                    	case 'EE1002':
                    		Popup.error('It looks like your account was deactivated.');
                    		break;
                    }
                    
	                $scope.login_started = false;
                }
                else if(status == 500) {
					Popup.error('Something went wrong :(');
					
	                $scope.login_started = false;
                }

            });
        }


        /**
         * called then user logins via facebook button
         */
        $scope.facebookLogin = function(){

			FB.login(function(response) {
				
				Auth.fbConnect(response.authResponse.accessToken, function(resp, status){
					if( status == 200 ){
						// success
	                    Auth.setCredentials(resp.data.user);

	                    // get credit
	                    User.getCredit(function(){
	                    	
		                    // this will go to intended or landing page
		                    Auth.redirectIfLoggedIn();
	                    });
					}
					else if( status == 500 ){
						Popup.error(Helper.getProperty(resp, 'data.message'));
					}
				});

			}, {scope: 'email'});
		}


		/**
		 * called when user clicks on forgot password button
		 */
		$scope.forgotPassword = function(){

			var email = $scope.username || '';

			// first do some simple validation
			if( email == '' ){
				Popup.error('Please enter your email address.');
				return;
			}
			if( ! Helper.validateEmail(email) ){
				Popup.error('Please enter a valid email address.');
				return;
			}

			// contact api to send an email with new password to user
			Auth.forgotPassword(email, function(resp, status){
				
				if( status == 200 ){
					Popup.success('New password has been successfully sent!');
				}
				else if( status == 404 ){
					Popup.error('There is no account associated with '+email+'.');
				}
				else{
					Popup.error('Something went wrong :(');
				}
			});

		}


    }]);